import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { favoritePagesActions } from '@src/ducks/favoritePages';
import { isFailed } from '@src/global/status';
import {
    getFavoritePagesStatus,
    getFavoritePagesError,
    getFavoritePages,
} from '@src/selectors/favoritePages';

const useFavoritePages = (params) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(favoritePagesActions.request(params));
    }, [params, dispatch]);

    const status = useSelector(getFavoritePagesStatus);
    const error = useSelector(getFavoritePagesError);
    const pages = useSelector(getFavoritePages);

    return [status, isFailed(status) ? error : pages];
};

export { useFavoritePages };
